import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { environment } from '../../../environments/environment';
import { NotificationsSettingsModel } from '@models/notifications/notificationSettings.model';
import { StorageService } from '../Logic/storage.service';

@Injectable()
export class NotificationSettingsService {
  baseHref = `${environment.apiUrl}/notification-settings`;

  constructor(
    private http: HttpClient,
    private storage: StorageService,
  ) {}

  getSettings(): Observable<NotificationsSettingsModel> {
    const url = `${this.baseHref}`;
    return this.http.get<any>(url);
  }

  changeSettings(data: any): Observable<NotificationsSettingsModel> {
    const url = `${this.baseHref}`;
    return this.http.put<any>(url, data);
  }

  unsubscribeEmailNotif(userId: number): Observable<any> {
    const url = `${this.baseHref}/unsubscribe-mail-notif/${userId}`;
    return this.http.get(url);
  }

  unsubscribeNonEssentialEmails(): Observable<any> {
    if (!this.storage.user) {
      return throwError(
        () =>
          new Error(
            'Du skal være logget ind for at kunne ændre dine notifikationsindstillinger',
          ),
      );
    }
    const url = `${this.baseHref}/unsubscribe-marketing-emails`;
    return this.http.get(url);
  }
}
